import { cleanEntry, getNumberFromText } from './../helpers/helpers';
import { createId, jsonCopyObject, sortByPropOfNumber } from './../../../globals/helpers/helpers';

import { Account, accountBudgetRateKeys, AccountClipboardPage, AccountPublicInfo, AccountUsers, DBAccountPropertyWhiteList, Docket, getPublicAccountFromAccount, LineItemTemplate, standardizeAccount, standardizeAccountClipboardPage } from '../../../globals/store/accounts.data';
/**
 * Created by greg on 12/07/2018.
 */
import { Router } from '@angular/router';
import { EnvironmentInjector, inject, Injectable, runInInjectionContext } from '@angular/core';
import { combineLatest, Observable, Subject, Subscription, merge, lastValueFrom } from 'rxjs';
import { EventStreamChange } from '../models/$event.model';
import { ErrorStreamChange } from '../models/$error.model';
import { UserService } from './user.service';
import { LogService} from './log.service';
import { take, takeUntil, tap, first} from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { UiService } from "./ui.service";
import { Store, select } from '@ngrx/store';
import { eventsFeature, JoiEvent, LOAD_ALL_EVENTS_FLAG } from '../store/events.era';
import { missingPublicInfoIdsReselector } from '../store/reselectors/accounts.reselector';
// port { DeleteAccount } from '../store/shared.models.actions';
import { EventListInfo } from '../../../globals/store/share.event-lists.data';
import { SectionSettings } from '../../../globals/store/budget.data';
import { JoiAccount } from '../../../globals/store/accounts.data';
import { Dictionary } from '@ngrx/entity';
import { accountActions, accountsFeature } from '../store/accounts.era';
import { userFeature } from '../store/user.era';
import { uiActions, uiFeature } from '../store/ui.era';
import { collection, collectionChanges, doc, DocumentChange, Firestore, docSnapshots, onSnapshot, query, where, DocumentReference, DocumentData, updateDoc, setDoc, QuerySnapshot } from '@angular/fire/firestore';



@Injectable({ providedIn: 'root'})
export class AccountsService {

    readonly _file:string = 'accounts.service.ts'
    readonly api = `${environment.functionsURL}api/app`;
    public suspendedAccounts = {};
    public account_in_payment_process:any = {};

    public processing = {};
    
    public plans:any;
    public currencies:string[] = ['AUD'];
    
    _iGotTheAccounts = false
    private docketsToGet = 0
    private _docketSubscriptions: { [key:string]: Subscription } = {}
    private _accountUsersSubscriptions: { [key:string]: Subscription } = {}

    public $destroy: Subject<boolean> = new Subject();
    public $destroy_user: Subject<boolean> = new Subject();
    public $destroy_event_account: Subject<boolean> = new Subject();
    public $destroy_accounts: Subject<boolean> = new Subject();

    public $events: Subject<EventStreamChange> = new Subject();
    public $errors: Subject<ErrorStreamChange> = new Subject();
    workforceAccountsAttempted: Set<string> = new Set()
    private db: Firestore = inject(Firestore);
    private envInjector: EnvironmentInjector = inject(EnvironmentInjector);

    public readonly roles: any[] = [
        {value: 'admin', label: 'Administrator', key: 'admin', desc: [
                'Create and manage account users (and their permissions)',
                'Manage account subscription/billing',
                'View account budget reports (access on home screen)',
                'View and edit all events (by joining the event workforce)',
                'Access all individual event budgets',
                'Create new events',
            ]},
        {value: 'executive', label: 'Team Leader', key:'executive', desc: [
                'Create and manage account users (and their permissions)',
                'View and edit all events (by joining the event workforce)',
                'Access all individual event budgets',
                'Create new events',
            ]},
        {value: 'leader', label: 'Team Member', key:'leader', desc:[
                'View and edit all events (by joining the event workforce)',
                'Access to budget if event creator granted access',
                'Create new events',
            ]},
        {value: 'solo', label: 'Team Contributor', key:'solo', desc: [
                'Only view and edit events this member creates (or is invited to as part of the event workforce)',
                'Access to budget if event creator granted access',
                'Create new events',
            ]}];


      constructor( public log: LogService, public userService: UserService,
        public http:HttpClient, private ui:UiService,
        public router: Router, public store: Store
      ) {
        this.$destroy_user.subscribe(_ => {
          this._iGotTheAccounts = false
          this.docketsToGet = 0
        })
        this.$destroy_accounts.subscribe(_ => {
          this._iGotTheAccounts = false
          this.docketsToGet = 0
        })

        this.store.select(accountsFeature.selectSuspended).pipe(takeUntil(this.$destroy)).subscribe(suspended=> this.suspendedAccounts = suspended)
        
        this.store.select(missingPublicInfoIdsReselector).pipe(takeUntil(this.$destroy)).subscribe(missingPublicInfoIds => {
          if (missingPublicInfoIds.length > 0) {
            // console.log("Should be fetching new public_infos from the store with ids: ", missingPublicInfoIds)
            this.loadWorkforceAccountsFromServer(missingPublicInfoIds).catch(response=>{
              this.log.error({file:this._file, function:'init loadWorkforceAccountsFromServer() call', response, data:{missingPublicInfoIds}})
            })
          }
        })

        // react when no eventId is passed in the URL
        combineLatest(
          [this.store.pipe(select(userFeature.selectUser)),
          this.store.pipe(select(eventsFeature.selectEventId))]
        ).pipe(takeUntil(this.$destroy)).subscribe({next:([user, eventId])=>{
          const uid = user ? user.uid : null;
          if(!uid) this.$destroy_user.next(true);
          console.log({ eventId, uid, igot:this._iGotTheAccounts })
          if(!eventId || !uid || this._iGotTheAccounts || eventId !== LOAD_ALL_EVENTS_FLAG) return; // if page is not loaded or you already got your accounts
          this.getAccounts();
        }})

        // accountId is triggered when eventId is selected
        this.store.pipe(select(accountsFeature.selectAccountId)).pipe(takeUntil(this.$destroy)).subscribe((accountId)=>{
          if(accountId) this.getEventAccount(accountId);
        })

        this.store.pipe(select(eventsFeature.selectEvents_unloading)).pipe(takeUntil(this.$destroy)).subscribe(is_unloading=>{
          if(is_unloading) {
            // console.log({ is_unloading});
            this.$destroy_accounts.next(true);
            this.workforceAccountsAttempted = new Set()
            this.store.dispatch(accountActions.accountsUnloading())
          }
        })
    }

    async checkAndUpdateBudgetSectionSettingsDefaults(settings: Partial<SectionSettings>) {
      if (!settings) return
      const account = await lastValueFrom(this.store.pipe(select(accountsFeature.selectAccount)).pipe(take(1))) as JoiAccount
      const changes: Partial<Account> = {}
      let hasChanges = false;
      (accountBudgetRateKeys as string[]).filter(k => settings[k]).forEach(k => {
        if (account[k] !== settings[k]) {
          hasChanges = true
          changes[k] = settings[k]
        }
      })
      // console.log({ hasChanges, changes })
      if (hasChanges) this.updateAccount(account.id, changes, { file: this._file, function: 'checkAndUpdateBudgetSectionSettingsDefaults' })
    }

    queryForAccountManagers = (accountId: string) => query(
      collection(this.db, 'account_users'),
      where('id', '==', accountId),
      where('managers', 'array-contains', this.userService.uid)
    )

    queryForAccounts = (accountId: string, uid: string) => query(
      collection(this.db, 'accounts'),
      where('id', '==', accountId),
      where('users', 'array-contains', uid)
    )

    // refForAccountDocket = <T>(accountId: string) => doc(this.db, `dockets/${accountId}`) as DocumentReference<T>;
    refForAccountDocket = <T>(accountId: string) => runInInjectionContext(this.envInjector, () => doc(this.db, `dockets/${accountId}`) as DocumentReference<T>) 


    async getEventAccount(accountId){
      console.log('getEventAccount ',accountId, this.userService.uid);

      if(!accountId) return console.log('accountId IS MISSING', accountId);
      console.log({ accountId, uid: 'searching' }  )
      const authUser = await lastValueFrom(this.store.pipe(select(userFeature.selectUser)).pipe(take(1)))
      console.log({ accountId, uid: authUser ? authUser.uid : null }  )
      new Observable((subscriber) => {
        const unsubscribe = onSnapshot(this.queryForAccounts(accountId, authUser ? authUser.uid : this.userService.uid),
          {
            next: (snapshot) => subscriber.next(snapshot.docChanges()),
            error: (error) => subscriber.error(error)
          }
        )
        return () => unsubscribe()
      }).pipe(
        takeUntil(this.$destroy_user),
        takeUntil(this.$destroy_event_account)
      )
      .subscribe({next:async (changes:DocumentChange<Account>[]) => {
          if(changes.length === 0){
            const currentPublicAccount = await lastValueFrom(this.store.select(accountsFeature.selectPublic_info).pipe(take(1)));
            if(currentPublicAccount && currentPublicAccount[accountId]) return;
            await this.loadWorkforceAccountsFromServer([accountId])
          }else{
            this.handleEventAccountChangesFromDB(changes, accountId)
          }
        },
        error: response=>this.log.error({file:this._file, function:'getEventAccount-account', response, error: new Error()})}
      );
      
    }

    initializeAccountsFromChangeAction(change: DocumentChange<Account>, uid:string) {
      const account: Account = change.doc.data()
      // console.log({ account })
      account.id = change.doc.id // cheaply ensure that the id and DB id are always in sync
      if(!account || !account.users) return;
      if(!account.labels) account.labels = this.ui.defaultLabels
      standardizeAccount(account, uid)
      if (account.invitation && !account.userInfo) setTimeout(()=>this.attachInviteSender(account.id) )
      return account
    }

    subscribeToSelectedEventAccountUsers(accountId) {
      this._accountUsersSubscriptions[accountId] = collectionChanges(this.queryForAccountManagers(accountId))
      .pipe(
        takeUntil(this.userService.loggedOut$),
        takeUntil(this.$destroy_user),
        takeUntil(this.$destroy_event_account)
      ).subscribe((changes)=> {
        changes.forEach(c=>{
          const data = c.doc.data() as AccountUsers;
          const userInfo = data.userInfo ? data.userInfo : [];
          this.store.dispatch(accountActions.modifyAccount(accountId, { userInfo }))
        })
      },(response)=>{
        this.log.error({file:this._file, function:'init get event account docket',response, error:new Error()})
      })
    }

    subscribeToSelectedEventAccountDocket(accountId) {
      this._docketSubscriptions[accountId] = docSnapshots<Docket>(this.refForAccountDocket(accountId)).pipe(
        takeUntil(this.userService.loggedOut$),
        takeUntil(this.$destroy_user),
        takeUntil(this.$destroy_event_account)
      ).subscribe({next: (docket_doc)=> {
        const docket = docket_doc.data();
        console.log({ docketPayload: docket_doc, docket })
        this.subscribeToAccountDocket(accountId, docket)
      }, error: (response)=>{
        this.log.error({file:this._file, function:'init get event account docket',response, error:new Error()})
      }})
    }

    subscribeToDocket(accountId) {
      this._docketSubscriptions[accountId] = runInInjectionContext(this.envInjector, () => docSnapshots<Docket>(this.refForAccountDocket(accountId)).pipe(
        takeUntil(this.userService.loggedOut$),
        takeUntil(this.$destroy_user),
        takeUntil(this.$destroy_accounts)
      ).subscribe({next: (docket_doc)=> {
        const docket = docket_doc.data();
        this.subscribeToAccountDocket(accountId, docket, true)
      }, error: async(response)=>{
        const accounts = await lastValueFrom(this.store.pipe(select(accountsFeature.selectEntities)).pipe(take(1))) as Dictionary<Account>;
        const account = accounts[accountId];
        const publicInfos = await lastValueFrom(this.store.pipe(select(accountsFeature.selectPublic_info)).pipe(take(1))) as Dictionary<AccountPublicInfo>;
        const public_info = await publicInfos[accountId]; 
        if (!account && !public_info) return // account was deleted, don't error
        this.log.error({file:this._file, function:`subscribeToDocket(accountId[${accountId}])`, response, error:new Error()})
      }}))
    }

    subscribeToAccountDocket(accountId:string, docket?:Docket, outsideEvent = false) {
      console.log({ docket, accountId, outsideEvent })
      if(docket && docket.expiration){
        const diff = this.getRemainingDays(docket.expiration)
        // if active account has expired, investigate
        if(diff < 1 && this.isActiveStatus(docket.status)){
          this.investigateExpiredAccount(accountId).pipe(take(1)).subscribe()
        }
        docket.days_remaining = diff+'';
        if(docket.stripePlanId){
          const bits = docket.stripePlanId.split('_');
          docket.summary = 'billed per ' + bits[2];
        }
        if(!docket.tally) docket.tally = 0;
      }
      if (docket) {
        const docket_update:Partial<Account> = { docket }
        this.store.dispatch(accountActions.updateAccountDocket(accountId, docket_update))
        if (outsideEvent) {
          this.docketsToGet -= 1
          if (this.docketsToGet === 0) this._iGotTheAccounts = true
        }
        

        this.store.pipe(select(uiFeature.selectTakeover_loading), takeUntil(this.$destroy_accounts)).subscribe(takeover_loading=>{
          if(takeover_loading === 'account') {
            this.router.navigate(['/home']).then(()=>{
              console.log('navigated to home after takeover loading')
              this.store.dispatch(uiActions.updateUIItem('takeover_loading',null ))
            })
          }
        })
      } else {
        console.log("COULD NOT GET DOCKET (PROBABLY FOR BRAND NEW ACCOUNT ON FIRST LOG IN)", { docket, accountId })
      }
    }

    tryUnsubscribeDocket(accountId) {
      if (this._docketSubscriptions[accountId]) {
        if (!this._docketSubscriptions[accountId].closed) {
          console.log("Unsubscribing from docket for account: " + accountId)
          this._docketSubscriptions[accountId].unsubscribe()
        }
        delete this._docketSubscriptions[accountId]
      }
    }

    attachInviteSender(accountId){
      this.store.pipe(select( accountsFeature.selectEntities), take(1)).subscribe(accounts=>{
        const account = accounts[accountId];
        if(!account || !account.invite_sender){
          const url = `${this.api}/get-invite-sender`;
          this.http.post(url, { accountId }).pipe(take(1)).subscribe(sender=>{
            this.store.dispatch(accountActions.modifyAccount(accountId, {invite_sender:sender}));
          })
        }
      })
    }

    async getAccount(accountId: string): Promise<JoiAccount> {
      const accounts = await lastValueFrom(this.store.pipe(select(accountsFeature.selectEntities), take(1)))
      return accounts[accountId];
    }
    
    getAccounts(){
      console.log('getAccounts');
      //  this.$destroy_event_account.next();
      this.store.dispatch(accountActions.accountsLoading(true))
      if(!this.userService.uid) console.log('UID IS MISSING', this.userService.uid);
      runInInjectionContext(this.envInjector, () => collectionChanges(query(
        collection(this.db, 'accounts'),
        where('users', 'array-contains', this.userService.uid)
      )))
      .pipe(
        tap(a=>console.log('accounts collectionChanges ', a)),
        takeUntil(this.$destroy_user),
        takeUntil(this.$destroy_accounts)
      )
      .subscribe({
        next: (changes:DocumentChange<Account>[]) => this.handleAccountChangesFromDB(changes), 
        error: response=> this.log.error({file:this._file, function:'getAccounts', response, error: new Error() })
      })
      this.connectToSupplements();
      // this.afs.collection('account_users', ref => ref.where('managers', 'array-contains', this.userService.uid))
      // .stateChanges()
      // .pipe(
      //   tap((changes:DocumentChangeAction<Account>[]) => this.handleAccountUserChangesFromDB(changes)),
      //   takeUntil(this.$destroy_user),
      //   takeUntil(this.$destroy_accounts)
      // )
      // .subscribe(()=>{}, response=> this.log.error({file:this._file, function:'getAccounts', response, error: new Error()}))
    }

    connectToSupplements(){
      runInInjectionContext(this.envInjector, () => collectionChanges(query(
        collection(this.db, 'account_users'),
        where('managers', 'array-contains', this.userService.uid)
      )))
      .pipe(
        takeUntil(this.$destroy_user),
        takeUntil(this.$destroy_accounts)
      )
      .subscribe((changes:DocumentChange<Account>[]) => {
        changes.forEach(c => {
          let supplement_type;
          let supplement;
          if(c.doc.ref.path.includes('account_users')) supplement_type = 'account_users';
          const data = c.doc.data();
          switch(supplement_type){
            case 'account_users':
              supplement = {userInfo:(c.type === 'removed' ? [] : data.userInfo)};
              break;
          }
          this.store.dispatch( accountActions.supplementalAccount(c.doc.id, supplement))
        })
      })
    }

    // handleAccountUserChangesFromDB(changes:DocumentChangeAction<Account>[]){
    //   // console.log('handleAccountUserChangesFromDB changes ', changes);
    //   const uid = this.userService.uid;
    //   changes.filter(c => c.type !== 'added').forEach(change=>{
    //     switch(change.type){
    //       case 'modified':
    //         const { userInfo } =  change.payload.doc.data()
    //         this.store.dispatch(new ModifyAccount(change.payload.doc.id, {userInfo}))
    //         break;
    //     }
    //   })
    //   const accountUsersToAdd = changes.filter(c=> c.type === 'added')
    //   if(accountUsersToAdd.length){
    //     accountUsersToAdd.forEach(accountUsers=>{
    //       const {userInfo} = accountUsers.payload.doc.data();
    //       this.store.dispatch(new ModifyAccount(accountUsers.payload.doc.id, { userInfo }))
    //     })
    //   }
    //   // console.log('Adding these accounts & dockets!', accountsToAdd.map(({id}) => id))

    // }

    async handleAccountChangesFromDB(changes:DocumentChange<Account>[]){
      console.log('handleAccountChangesFromDB changes ', changes);
      // console.log({ theTypes:changes.map(c=>({ account:c.type, account_user: types[c.payload.doc.id]}))});
      const uid = this.userService.uid;
      changes.filter(c => c.type !== 'added').forEach(change=>{
        switch(change.type){
          case 'modified':
            this.store.dispatch(accountActions.modifyAccount(change.doc.id, this.initializeAccountsFromChangeAction(change, uid)))
            break;
          case 'removed':
            this.tryUnsubscribeDocket(change.doc.id)
            this.store.dispatch(accountActions.removeAccount(change.doc.id));
            break;
        }
      })


      if(changes.length === 0){
        this.store.dispatch(accountActions.setDocketLoadingStatus(false)) // I am assuming that changes.length of 0 means there were no accounts that could be gotten, and not something else
        this._iGotTheAccounts = false // needed for the case of creating a new account when none exists, and then navigating back to the dashboard once more after navigating back to the dashboard and creating an event from the dashboard (without logging out and then logging in)
        this.store.dispatch(accountActions.accountSuccess())
        return
      }
      const accountsToAdd: Account[] = changes.filter(c=> c.type === 'added').map(change=>this.initializeAccountsFromChangeAction(change, uid)).filter(acc=>!!acc)
      console.log({ accountsToAdd});
      if(accountsToAdd.length){
        const public_info_additions: { [id: string]: AccountPublicInfo } = {}
        accountsToAdd.forEach(account=> public_info_additions[account.id] = getPublicAccountFromAccount(account, { status: null }))
        console.log({ public_info_additions })
        this.store.dispatch( accountActions.updateAccountPublicInfo(public_info_additions))
        this.store.dispatch(accountActions.addManyAccounts(accountsToAdd, this.userService.uid))
        this.docketsToGet += accountsToAdd.length

        accountsToAdd.forEach(account => runInInjectionContext(this.envInjector, () => collectionChanges(query(
            collection(this.db, 'clipboards'),
            where('accountId','==',account.id)
          ))
          .pipe(
            tap((changes:DocumentChange<AccountClipboardPage>[]) => this.handleMultipleAccountClipboardChangesFromDB(changes, account.id)),
            takeUntil(this.$destroy_user),
            takeUntil(this.$destroy_accounts)
          )
          .subscribe({next:()=>{},
            error: response=>this.log.error({file:this._file, function:'getEventAccount-clipboard', response, error: new Error()})
          })
        ))
        accountsToAdd.forEach(({ id }) => this.subscribeToDocket(id))
      }


    }


    async handleEventAccountClipboardChangesFromDB(changes: DocumentChange<AccountClipboardPage>[], accountId: string) {
      const clipboardPages = changes.map(c => c.doc.data()).map(standardizeAccountClipboardPage)
      // console.log({ changes, accountId, clipboardPages })
      this.store.dispatch(accountActions.addClipboardPages(clipboardPages))
    }

    async handleMultipleAccountClipboardChangesFromDB(changes: DocumentChange<AccountClipboardPage>[], accountId: string) {
      const clipboardPages = changes.map(c => c.doc.data()).map(standardizeAccountClipboardPage)
      console.log({ changes, accountId, clipboardPages })
      try{
        this.store.dispatch(accountActions.addManyAccountsClipboardPages(accountId, clipboardPages))
      }catch(e){
        console.error(e)
      }
    }

    async handleEventAccountChangesFromDB(changes: DocumentChange<Account>[], accountId:string){
      console.log('handleEventAccountChangesFromDB changes ', changes);
      const uid = this.userService.uid;
      const accountsToAdd: Account[] = changes.filter(c=> c.type === 'added').map(change=>this.initializeAccountsFromChangeAction(change, uid))
      const accountsToModify: Account[] = changes.filter(c=> c.type === 'modified').map(change=>this.initializeAccountsFromChangeAction(change, uid))
      if(accountsToAdd.length === 1){
        accountsToAdd.forEach(account=> {
          const info:AccountPublicInfo = getPublicAccountFromAccount(account, { status: null })
          this.subscribeToSelectedEventAccountDocket(account.id)
          this.store.dispatch(accountActions.updateAccountPublicInfo({[account.id]:info}))
          this.store.dispatch(accountActions.loadEventAccount(account));
          console.log({account, msg:'subscribing to clipboard changes for this account'})
          this.subscribeToSelectedEventAccountUsers(account.id)
            collectionChanges(query(
              collection(this.db, 'clipboards'),
              where('accountId','==',accountId)
            ))
            .pipe(
              tap((changes:DocumentChange<AccountClipboardPage>[]) => this.handleEventAccountClipboardChangesFromDB(changes, accountId)),
              takeUntil(this.$destroy_user),
              takeUntil(this.$destroy_event_account)
            )
            .subscribe({error: response=>this.log.error({file:this._file, function:'getEventAccount-clipboard', response, error: new Error()})}
            )
        })
      } else if (accountsToModify.length === 1) {
        accountsToModify.forEach(account=>{
          this.store.dispatch(accountActions.updateSelectedEventAccount(account));
        })
      } else {
        // get public info
        console.log('handle event account missing ', accountId)
        const publicAccounts: Dictionary<AccountPublicInfo> = (await this.loadWorkforceAccountsFromServer([accountId])) || {}
        if (publicAccounts[accountId]) {
          this.store.dispatch(accountActions.loadEventAccount(publicAccounts[accountId]))
          console.log({account: publicAccounts[accountId], msg:'subscribing to clipboard changes for this account'})
        }
        else console.log(' could not even find it on the public')
        // console.log(' you aren\'t on this account!!!')
      }
    }

    async updateEventListInfo(accountId: string, eventListInfo: EventListInfo) {
      const account = await this.getAccount(accountId)
      account.eventListInfos[eventListInfo.publishCode] = eventListInfo
      await this.updateAccount(accountId, { eventListInfos: account.eventListInfos }, {file:this._file, function:'updateEventListInfo', error:new Error()})
    }

    updateEventListInfos(accountId: string, eventListInfos: { [id: string]: EventListInfo }) {

      console.log({ eventListInfos })
      this.updateAccount(accountId, { eventListInfos }, {file:this._file, function:'updateEventListInfos', error:new Error()})
    }

    async updateAccount(accountId:string, changes:Partial<Account>, log_data:Partial<ErrorStreamChange>): Promise<void> {
      const ref = doc(this.db, `accounts/${accountId}`)

      const updated_account = cleanEntry(changes, DBAccountPropertyWhiteList)
      try {
        await updateDoc(ref, updated_account)
      } catch (error) {
        this.log.error({
          response: error,
          data:{ accountId, changes},
          error: new Error,
          message: 'There was an error updating the Account',
          ...log_data
        });
      }
       
    }

    updateAccountUsers(accountId:string, user_changes:Partial<AccountUsers>, changes?:Partial<Account>, log_data:Partial<ErrorStreamChange> = {}){
      const ref = doc(this.db, `account_users/${accountId}`)
      updateDoc(ref, user_changes).then(()=>{
        if(changes) this.updateAccount(accountId, changes, log_data)
      }).catch(response => {
        this.log.error({
            response,
            data:{ accountId, changes},
            error: new Error,
            message: 'There was an error updating the Account',
            ...log_data
        });
      })
    }

    async removeAccountUser(accountId:string, email:string, uid:string = null, log_data:Partial<ErrorStreamChange> = {}){
      try {
        const accounts = await lastValueFrom(this.store.select(accountsFeature.selectEntities).pipe(take(1)))
        const account:Account = accounts[accountId];
        if(!account || (!uid && !email)) return;
        if(account.owner === uid) return;
        const { users, userInfo, admin, executive, solo, leader, invitation } = account;
        const canUpdateAccountUsers = account.admin.includes(this.userService.uid) || account.executive.includes(this.userService.uid)
        let update_user_obj:Partial<AccountUsers> = canUpdateAccountUsers ? { userInfo: userInfo.filter(u=>u.email!==email)  } : null;
        if(uid){
          const update_obj = {
            users: users.filter(u=>u!==uid),
            admin: admin.filter(u=>u!==uid),
            executive: executive.filter(u=>u!==uid),
            leader: leader.filter(u=>u!==uid),
            solo: solo.filter(u=>u!==uid),
            invitation: invitation.map(inv=>{
              if(inv.receiver !== email && inv.receiver !== uid) return inv
              inv.status = 'cancelled'
              return inv;
            })
          }
          try {
            await updateDoc(doc(this.db, 'accounts/'+accountId), update_obj)
          } catch(e) {
            this.log.error({
              response: e.toString(),
              data:{accountId, email, uid},
              error: new Error,
              message: 'There was an error removing this user - update obj',
              ...log_data
            });
          }
          update_user_obj = canUpdateAccountUsers ? {
            managers: [...update_obj.admin, ...update_obj.executive],
            userInfo: userInfo.filter(u=>u.uid!==uid),
            users: users.filter(u=>u!==uid),
          } : null;
        }
        if(canUpdateAccountUsers) await updateDoc(doc(this.db, 'account_users/'+accountId), update_user_obj)
        else await this.http.post(`${this.api}/remove-self-from-account-users`, {accountId}).pipe(take(1)).toPromise()

        if(uid){
          const url = `${this.api}/audit-user-accounts`;
          await this.http.post(url, { uid }).pipe(take(1)).toPromise()
        }else{
          const url = `${this.api}/clear-requested`;
          await this.http.post(url, { email: email, type:'account',id:account.id}).pipe(take(1)).toPromise()
        }

      } catch(e) {
        this.log.error({
          response: e.toString(),
          data:{accountId, email, uid},
          error: new Error,
          message: 'There was an error removing this user',
          ...log_data
        });
      }
    }

    getRemainingDays(exp){
      const exp_date = exp.toDate();
      const date = new Date();
      const diff = Math.ceil((exp_date.getTime() - date.getTime()) / 1000 / 60 / 60 / 24 + 1);
      return diff;
    }

    // sets public_info for those that don't have it
    setWorkforceAccounts(events:JoiEvent[]){ // called from groups on dashboard
      this.store.pipe(select(accountsFeature.selectPublic_info), take(1)).subscribe(public_info=>{
        const accountIds = new Set(events.map(ev=>ev.accountId).filter(accountId => !this.workforceAccountsAttempted.has(accountId)))
        this.loadWorkforceAccountsFromServer(Array.from(accountIds))
      })
    }


    async loadWorkforceAccountsFromServer(fullAccountIdsList: string[]) {
      const accountIds = fullAccountIdsList.filter(id => !this.workforceAccountsAttempted.has(id))
      // console.log({ accountIds, fullAccountIdsList })
      if(!accountIds || accountIds.length === 0) return;
      accountIds.forEach(id => this.workforceAccountsAttempted.add(id))

      const url = `${this.api}/get-public-accounts-info`;
      try {
        const public_info_from_db: { [id: string]: AccountPublicInfo } = await this.http.post(url, { accountIds }).toPromise() as any
        // console.log({ public_info_from_db })
        this.store.dispatch( accountActions.updateAccountPublicInfo(public_info_from_db))
        return public_info_from_db
      } catch (response) {
        this.log.error({file:this._file, function:'loadWorkforceAccountsFromServer',response,error:new Error(),data:{ accountIds }})
        return {}
      }
    }

    setPlans(){
      if(this.plans) return;
      collectionChanges(query(
        collection(this.db, '_system'),
        where('_plan_status', '==', 'active')
      ))
      .pipe(
        tap((changes:DocumentChange<any>[]) => {
          if(changes.length === 0 || !changes[0].doc.exists) return;
          const plans = changes[0].doc.data();
          if(!plans) {
            return;
          }
          const costings = {}
          const quantities = plans.quantities;
          this.currencies = plans.currencies;
          const intervals = plans.intervals;
          const plan_prefix = plans._plan_prefix
          const costs = Object.keys(plans.costings);
          costs.forEach( cost_str => {
            const cost = parseFloat(cost_str);
            plans.costings[cost_str].forEach( stub => {
              costings[stub] = cost;
            })
          })
          quantities.sort((a,b)=>a-b);
          this.currencies.sort();
          intervals.sort();
          this.plans = {quantities,currencies:this.currencies,intervals,costings,plan_prefix};
          console.log('plans ', plans);
          // I don't think I need to be doing this every time!!!
          // const url = `${this.api}/stripe-get-plans`;
          // this.http.post(url, { plans:this.plans }).pipe(take(1)).subscribe(stripePlans => {
          //   console.log('stripePlans ', stripePlans);
          // });
        },
        response=>this.log.error({file:this._file, function:'setPlans', response, error: new Error()})
        ),
        takeUntil(this.$destroy_user)
      )
      .subscribe()

    }

    investigateExpiredAccount(accountId:string){
      const url = `${this.api}/investigate-expired-account`;
      return this.http.post(url, { accountId })
    }

    async saveCountry(accountId, country, currency){
      try {
        await updateDoc(doc(this.db, 'accounts/'+accountId), {country, currency})
      } catch(e) {
        this.log.error({file:this._file,function:"saveCountry",error:new Error(), data:{accountId, country, currency}})
      }
    }

    isActiveStatus(status){
      return ['active','trial','beta'].indexOf(status) > -1;
    }

    updateDefaultAccount(accountId){
      setDoc(doc(this.db, 'users/'+this.userService.uid), {lastUsedAccountId:accountId}, {merge:true});
    }

    deleteAccount(accountId){
        // this.store.dispatch(new DeleteAccountFromUser(accountId))
        this.store.dispatch( accountActions.deleteAccount(accountId))
        this.tryUnsubscribeDocket(accountId) // <== should do here and not on the round trip back.  Leaving when it comes back in case the account was deleted from elsewhere
        const url = `${this.api}/delete-account`;
        return this.http.post(url, {accountId})
    }

    setSelectedAccount(selected_accountId:string){
      this.store.dispatch(accountActions.updateUserSelectedAccount(selected_accountId))
    }

    rerouteIfNotAdminOrExec(account){
      if(!account || ( !account.is_admin && !account.is_exec ) ) {
        this.router.navigate(['/home'])
      }
    }

    addAccount(title:string): Observable<any>{
        const url = `${this.api}/add-account`;
        return this.http.post(url, {title });
    }
    inviteUser(member, accountId): Observable<any> {
        const url = `${this.api}/invite-account`;
        this.store.dispatch(accountActions.modifiedAccountUser(accountId, member.email, member, {file:this._file, function:'inviteUser'}))
        return this.http.post(url, { member, accountId });
    }

    accept(acc: JoiAccount) {
        this.sendReply(acc, 'accepted')
        console.log({ acc })
        this.store.dispatch(accountActions.addToJustInvitedList(acc.id))
    }
    decline(acc: JoiAccount) {
        this.sendReply(acc, 'declined')
    }
    sendReply(acc: JoiAccount, reply: 'accepted' | 'declined'): Promise<void>{
      return new Promise((resolve,reject)=>{
        this.processing[acc.id] = true;
        const url = `${this.api}/invite-account-reply`;
        this.http.post(url, { accountId:acc.id, reply})
          .pipe(take(1))
          .subscribe(()=>{
            setTimeout(_=>{ this.processing[acc.id] = false },1000 * 4)
            resolve()
          },(response)=>{
            this.log.error({file:this._file,
              error: new Error(),function:'sendReply '+reply,data:{accountId:acc.id, reply},response})
            this.processing[acc.id] = false;
            reject(response)
          })
      })
    }
    
    async saveLineItems(account: Partial<JoiAccount>) {
      account.lineItems.sort(sortByPropOfNumber('sortNumber'))
      await this.updateAccount(account.id, { lineItems: account.lineItems }, { file: this._file, function: 'save' } )
    }
  
    addLineItem(account: Partial<JoiAccount>) {
      account = jsonCopyObject(account) as JoiAccount
      const sortNumber = !account?.lineItems?.length ? 1 : Math.max(...account.lineItems.map(l => l.sortNumber)) + 1
      account.lineItems.push({ id: createId(), sortNumber, name: '', unitRate: 0, unitCost: 0 })
      this.saveLineItems(account)
    }

    
  
    updateLineItemNumber(account: JoiAccount, item: LineItemTemplate, key: keyof LineItemTemplate, defaultValue = 0) {
      switch (key) {
        case 'sortNumber':
        case 'unitCost':
        case 'unitRate':
          item[key] = getNumberFromText(item[key], defaultValue)
          break
        default:
          console.log("Got a wrong key: " + key)
          break 
      }
      account = jsonCopyObject(account) as JoiAccount
      account.lineItems[account.lineItems.findIndex(i => i.id === item.id)] = item
      this.saveLineItems(account)
    }

}
